export const GENDER = {
  M: { code: 'M', text: '남성' },
  F: { code: 'F', text: '여성' },
  A: { code: 'A', text: '전체' },
} as const;

type GenderInfo = (typeof GENDER)[keyof typeof GENDER];

export type GenderCodeType = GenderInfo['code'];
export type GenderTextType = GenderInfo['text'];
